/**
 * defa.models.RoleApplication
 * The DEFA RoleApplication model.
 * @version 1.0.0
 */

import Model       from '../../poppet/model';
import { defa, T } from '../../../defa-object';

const channel = Bb.Radio.channel('objects');
const apiHost = defa.vars.apiHost;
const api = {
	unitUrl: apiHost,
	roleApplication: '/roleapplications/%s',
	approve: '/roleapplications/%s/approve',
	reject: '/roleapplications/%s/reject',
};



export const RoleApplication = Model.extend({
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: {
		customer : null,
		phoneNumber: null
	},
	
	url: function ( ) {
		return apiHost + api.roleApplication.replace('%s', this.get('id'));
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Parses incoming data before creating/updating the model.
	 * @param  {object} response  The response from the server.
	 * @overwrite
	 */
	parse: function(response){
		if(response.customer && response.phoneNumber){
			channel.request('roleApplications').add(response, {merge: true})
		}
		return response;
	},
	
	/**
	 * Approves the application.
	 * @param  {object} option  The error and success methods from the application view.
	 */
	_approve: function (options) {
		let id = this.get('id');
		this.save( {id:id}, { type: 'POST', url: apiHost + api.approve.replace('%s', id),
			success: function(model, response){
				options.success(response);
				channel.request('roleApplications').remove(model.id); // need to manually remove the model since this is a POST and not a DELETE call
			},
			
			error: function(model, response){
				console.error(response.responseJSON.message);
				options.error(response.responseJSON);
				
			},
		});
	},
	
	/**
	 * Rejects the application.
	 * @param  {object} option  The error and success methods from the application view.
	 */
	_reject: function (options) {
		let id = this.get('id');
		this.save( {id:id}, { type: 'POST', url: apiHost + api.reject.replace('%s', id),
			success: function(model, response){
				channel.request('roleApplications').remove(model.id);
				options.success(response);
			},
			
			error: function(model, response){
				console.error(response.responseJSON.message);
				options.error(response.responseJSON);
			},
	});
	}
});
export default RoleApplication;